import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import * as FormServices from "../../../../services/FormService";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import { PERSON_TYPES } from "../../../../constants/index";
import {
  ButtonAction,
  ButtonClose,
  Icon,
  Option,
  ListOptions,
} from "./formList.styled";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import {} from "../../../security/permissions/rolesPermission";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import {
  ShowAlertDialog,
  PaginateList,
} from "@de-prado-dev/react-component-library";

const FormListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const context = useContext(AbilityContext);

  const columns = [
    {
      header: t("forms.form.table.heads.name"),
      accessorKey: "name",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.form.table.heads.frontCode"),
      accessorKey: "frontCode",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.form.table.heads.personType"),
      accessorKey: "personType",
      cell: (info) => {
        const data = [];
        for (const dat of info.getValue()) {
          const personType = PERSON_TYPES.find(
            (type) => type.code === "" + dat
          );
          data.push(personType ? t(personType.label) + ", " : "-");
        }
        return data;
      },
    },
    {
      header: t("forms.form.table.heads.active"),
      accessorKey: "active",
      cell: (info) => {
        return info.getValue()
          ? t("forms.response.yes")
          : t("forms.response.no");
      },
    },
    {
      header: t("forms.form.table.heads.description"),
      accessorKey: "description",
      cell: (info) => info.getValue(),
    },
    {
      Header: t(" "),
      accessorKey: " ",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const goToEdit = (uuid) => {
    navigate(`/adm/form/form/update/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <div className="text-center">
        <ButtonAction onClick={() => goToEdit(data.uuid)} type="button">
          <i className="fa-regular fa-pen-to-square"></i>
        </ButtonAction>
        <ButtonAction
          onClick={() => showDialogOnDelete(data.uuid)}
          type="button"
        >
          <Icon className="fa-solid fa-trash-can"></Icon>
        </ButtonAction>
      </div>
    );
  };

  const showDialogOnDelete = (uuid) => {
    const okAction = async () => {
      FormServices.deleteForm(uuid).then((result) => {
        if (result && result.deleted === true) {
          setForceRefresh(true);
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.form.dialog.remove.title"),
      t("forms.form.dialog.remove.text"),
      "warning",
      true,
      t("forms.form.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.form.dialog.remove.buttonNo"),
      cancelAction
    );
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }
    const result = await FormServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    // hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    // hideColumn.itemCode = false;
  }

  return (
    <PaginateList
      refresh={forceRefresh}
      filters={filters}
      columns={columns}
      toList={listData}
      hideColum={hideColumn}
      resize={resize}
      resetRefresh={() => setForceRefresh(false)}
    ></PaginateList>
  );
};

FormListContainer.propTypes = {
  filters: PropTypes.object,
};

export default FormListContainer;
